import { Link } from 'react-router-dom';
import { photoUrl } from '../lib/api';

export const AccountAvatar = ({ user, small = false }) => (
  <Link to={user.role === 'parent' ? '/parent/profile' : '/passport'}
    className={`account-avatar ${small ? 'account-avatar-small' : ''}`}
    data-testid={small ? 'header-profile-link' : 'sidebar-profile-link'}
    aria-label={user.role === 'parent' ? 'Edit my profile photo' : 'Edit trainer Passport photo'}
    title={user.role === 'parent' ? 'My profile' : 'Trainer Passport'}>
    {user.photo_id ? <img src={photoUrl(user.photo_id)} alt={user.name} data-testid={small ? 'header-profile-photo' : 'sidebar-profile-photo'} /> : <span>{user.name[0]}</span>}
  </Link>
);